

// Autogenerated 2023-05-18 09:36:21.450990
// gen_js_enum.py proto/proto/time.proto src/lib/proto/time.js

const Cadence = {
  CADENCE_UNDEFINED: { value: 0, id: "CADENCE_UNDEFINED" },
  weekly: { value: 1, id: "weekly", label: "Weekly" },
  monthly: { value: 2, id: "monthly", label: "Monthly" },
  quarterly: { value: 3, id: "quarterly", label: "Quarterly" },
  annually: { value: 4, id: "annually", label: "Annually" },
};
export { Cadence };
